import { render } from "./Home.vue?vue&type=template&id=0d8bdaf8&bindings={\"search\":\"data\",\"searched\":\"data\",\"toots\":\"data\",\"tootsCount\":\"data\",\"isLoading\":\"data\",\"handleTagSeach\":\"options\",\"mastodonTagSearch\":\"options\",\"addTagToSearchedList\":\"options\",\"getAuthUserCode\":\"options\",\"getLoggedAccountDetail\":\"options\"}"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script